"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let GenerateMeterConsumptions = class GenerateMeterConsumptions extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "GenerateMeterConsumptions.item");
    }
    getPayload(...args) {
        const [item] = args;
        const result = _.pick(item, [
            'min_date',
            'max_date',
            'exact_period',
            'meter_types'
        ]);
        for (let field of [
            'contracts',
            'rentals',
            'companies',
            'tenants',
            'meters',
        ]) {
            if (_.isArray(item[field])) {
                result[field] = _.map(item[field], 'id');
            }
        }
        console.log(result, item);
        return result;
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    formName;
    item;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'formName', 'item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                formName: "GenerateMeterConsumptions",
                item: {
                    min_date: null,
                    max_date: null,
                    meters: null,
                    contracts: null,
                    rentals: null,
                    companies: null,
                    tenants: null,
                    exact_period: false,
                    meter_types: null,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("GenerateMeterConsumptions|Title", "Generate Consumptions"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4372_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_closeComponent_4374_getActionArgs($event) {
        return {
            result: {
                cancel: true,
            },
        };
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_closeComponent_4376_getActionArgs($event) {
        return {
            result: {
                close: true,
                ok: true,
                value: this.getPayload(this.item),
            },
        };
    }
    async evh_4186377094414664_submit(event, scope) {
        return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4372 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4372_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4371 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4372,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4371],
        });
        const act_2248226175642056_closeComponent_4374 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_2248226175642056_closeComponent_4374_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_close_4373 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4374,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4373],
        });
        const act_4186377094414664_closeComponent_4376 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_4186377094414664_closeComponent_4376_getActionArgs,
            displayName: "submit",
            events: [],
        });
        const evh_4186377094414664_submit_4375 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_closeComponent_4376,
            event: "submit",
            displayName: "submit",
        });
        const evh_4186377094414664_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_submit_4375],
        });
        const act_1419464017721962_closeComponent_4378 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4377 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_4378,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4377],
        });
        return {
            act_7315092382398562_closeModal_4372,
            evh_7315092382398562_close_4371,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4374,
            evh_2248226175642056_close_4373,
            evh_2248226175642056_close,
            act_4186377094414664_closeComponent_4376,
            evh_4186377094414664_submit_4375,
            evh_4186377094414664_submit,
            act_1419464017721962_closeComponent_4378,
            evh_1419464017721962_clickPreventStop_4377,
            evh_1419464017721962_clickPreventStop,
            submit: act_4186377094414664_closeComponent_4376,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], GenerateMeterConsumptions.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], GenerateMeterConsumptions.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], GenerateMeterConsumptions.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], GenerateMeterConsumptions.prototype, "onSize", null);
GenerateMeterConsumptions = __decorate([
    (0, vue_property_decorator_1.Component)()
], GenerateMeterConsumptions);
exports.default = GenerateMeterConsumptions;
vue_property_decorator_1.Vue.component("GenerateMeterConsumptions", GenerateMeterConsumptions);
